import React from "react";
import { useTheme } from "@reactive-resume/hooks";

export const LoadingPage = () => {
  const { isDarkMode } = useTheme();

  return (
    <div
      className={`flex h-screen w-screen items-center justify-center ${isDarkMode ? "bg-zinc-950" : "bg-gray-100"} ${isDarkMode ? "text-zinc-50" : "text-zinc-950"}`}
    >
      <div className="flex flex-col items-center">
        <div className={`mb-4 h-12 w-12 animate-spin rounded-full border-4 ${isDarkMode ? "border-zinc-200" : "border-zinc-800"} ${isDarkMode ? "border-t-zinc-800" : "border-t-zinc-200"}`} />
        <p className="text-lg font-medium">Loading...</p>
      </div>
    </div>
  );
};
